import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Row, Col } from "antd";
import { Controller } from "react-hook-form";
import { FormField, IButton, ISelect, Spinner } from "../../../../ui-kit";
import defectCardsStore from "../../../../store/defectCards";
import { useStatusMessage } from "../../../../hooks/useStatusMessage";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { webAPI } from "../../../../api/Api";

import styles from "./DefectNotify.module.scss";
import validate from "./validator";

const DefectNotify: React.FC<{
  defectId: string;
  onClose: () => void;
}> = observer(({ defectId, onClose }) => {
  const {
    defectNotifyStatus,
    defectNotifyFormIsSending,
    defectNotifyText,
    defectNotifyTextShort,
    defectNotifySettings,
    cards,
  } = defectCardsStore;
  const initialValues = {
    selectedGroupId: null,
    text: null,
    templateId: null,
    shortText: null,
  };
  const initialFocus = {};
  const {
    register,
    handleSubmit,
    watchAllField,
    setValue,
    isFocused,
    handleBlur,
    handleFocus,
    control,
    reset,
  } = useHandleForm(validate, initialValues, initialFocus);

  const [typeEvent, setTypeEvent] = useState("");

  useStatusMessage(defectNotifyStatus);

  useEffect(() => {
    defectCardsStore.getNotificationSettings(defectId);
    const card: { data: { eventType: { title: string } } } = cards?.find(
      ({ data }) => data?.id === +defectId,
    ) || {
      data: { eventType: { title: "" } },
    };
    const title = card.data?.eventType?.title;
    if (title) {
      setTypeEvent(title);
    } else {
      webAPI
        .get(`/sp/event/${defectId}`, {})
        .then((res) => {
          const title = res?.data?.eventType?.title;
          if (title) {
            setTypeEvent(title);
          }
        })
        .catch((error) => {
          setTypeEvent("");
          console.log(error);
        });
    }
  }, [defectId]);

  useEffect(() => {
    if (watchAllField.templateId) {
      setValue("text", defectNotifyText);
      setValue("shortText", defectNotifyTextShort);
    }
  }, [watchAllField.templateId, defectNotifyText, defectNotifyTextShort]);

  const onTemplateChanged = (value) => {
    defectCardsStore.getNotificationTemplateText(defectId, value);
  };

  const onSubmit = (values) => {
    defectCardsStore.sendDefectNotification(defectId, values);
  };

  const resetChanges = () => {
    reset(initialValues);
    onClose();
  };

  if (defectCardsStore.defectNotifySettingsAreLoading.value) {
    return (
      <div className={styles.defectNotify}>
        <Spinner />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.defectNotify}>
      <Row gutter={[10, 20]}>
        <Col span={24} className={styles.defectNotifyLabel}>
          {typeEvent ? typeEvent : "Тип дефекта не установлен"}
        </Col>
        <Col span={24}>
          <Controller
            control={control}
            name="selectedGroupId"
            render={({ field, fieldState: { error } }) => (
              <ISelect
                field={field}
                optionsArr={defectNotifySettings?.groups}
                placeholder="Группа для рассылки"
                error={error?.message}
                isRequired
              />
            )}
          />
        </Col>
        <Col span={24}>
          <Controller
            control={control}
            name="templateId"
            render={({ field }) => (
              <ISelect
                field={field}
                optionsArr={defectNotifySettings?.templates}
                placeholder="Шаблон для рассылки"
                onChange={onTemplateChanged}
              />
            )}
          />
        </Col>
        {defectNotifyText && watchAllField.templateId && (
          <Col span={24}>
            <FormField
              register={register}
              label="Автоматический текст шаблона email"
              name="text"
              type="textarea"
              currentValue={watchAllField.text}
              isFocused={isFocused.text}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </Col>
        )}
        {defectNotifyTextShort && watchAllField.templateId && (
          <Col span={24}>
            <FormField
              register={register}
              label="Автоматический текст шаблона sms"
              name="shortText"
              type="textarea"
              currentValue={watchAllField.shortText}
              isFocused={isFocused.shortText}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </Col>
        )}
      </Row>
      <Row className={styles.defectNotifyButtonWrapper}>
        <Col span={12} className={styles.defectNotifyButton}>
          <IButton disabled={defectNotifyFormIsSending.value}>
            Отправить
          </IButton>
        </Col>
        <Col span={12} className={styles.defectNotifyButton}>
          <IButton
            disabled={defectNotifyFormIsSending.value}
            onClick={resetChanges}
            variant="outlined"
            type="button"
          >
            Отменить
          </IButton>
        </Col>
      </Row>
    </form>
  );
});

export default DefectNotify;
